export default "__VITE_PUBLIC_ASSET__af1c1a9b__"